module.exports = __webpack_public_path__ + "static/img/41_pro.dee2902.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/41_pro.jpg
// module id = UMZI
// module chunks = 0